import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7OPCVMTimeSerieFilesEdit } from "./edit";
import { A7OPCVMTimeSerieFilesTable } from "./table";

export default function A7OPCVMTimeSerieFiles() {
  useEffect(() => {
    setDocumentTitle("Quantilia | OPCVM Fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7OPCVMTimeSerieFilesEdit />} />
      <Route index element={<A7OPCVMTimeSerieFilesTable />} />
    </Routes>
  );
}
